import {styled} from 'common'
import KeyValue from 'components/Display/KeyValue'

const TableExpand = ({itemName, item}) => {
    return (
        <Container>
            {!!itemName && <Subtitle>{itemName}</Subtitle>}
            <KeyValue object={item} />
        </Container>
    )
}

export default TableExpand

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    gap: 5px;
    width: 100%;
    box-sizing: border-box;
    max-width: 100%;
    overflow: hidden;
`

const Subtitle = styled.h1``
